import { CardLoader } from 'components/organisms'
import CustomerOrderTableRow from './customer-order-table-row'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import { ListPagination } from 'components/organisms'

const propTypes = {
  tableProps         : PropTypes.object,
  orders             : PropTypes.array,
  pagination         : PropTypes.object,
  onPageChange       : PropTypes.func,
  isLoading          : PropTypes.bool,
  showCustomerFields : PropTypes.bool
}

const defaultProps = {
  showCustomerFields: true
}

/**
 * Table to display ::Customer::Order data
 * @param {Object} tableProps - additional table props
 * @param {Array<Object>} orders - array of Customer::Order
 * @param {Object} Pagination - array of Customer::Order
 * @param {Function} onPageChange - Function that triggered on page change
 * @param {Boolean} showCustomerFields - show customer related columns
 */

const CustomerOrderTable = ({
  tableProps,
  orders,
  pagination,
  onPageChange,
  showCustomerFields,
  isLoading
}) => {

  const totalColumns = showCustomerFields ? 10 : 7
  const isOrderEmpty = orders.length === 0

  const TableContent = () => (
    <Table
      hover
      style={{ height: 'fit-content' }}
      { ...tableProps }
    >
      <thead>
        <tr>
          <th scope="col">{ 'Number' }</th>
          <th scope="col">{ 'Order Date' }</th>
          <th scope="col">{ 'Status' }</th>
          <th scope="col">{ 'Payment Method' }</th>
          <th scope="col">{ 'Voucher Code' }</th>
          <th scope="col">{ 'Items SKU' }</th>
          <th scope="col">{ 'Affiliate' }</th>
          {
            showCustomerFields && (
              <th scope="col">{ 'Customer' }</th>
            )
          }
        </tr>
      </thead>
      <tbody>
        {
          orders.map((customerOrder) => (
            <CustomerOrderTableRow
              key={ `CustomerOrderTableRow-${customerOrder.id}` }
              order={ customerOrder }
              showCustomerFields={ showCustomerFields }
            />
          ))
        }
        {
          isOrderEmpty && (
            <tr>
              <td
                colSpan={ totalColumns }
                className='bg-warning text-white'
              >
                <i className='fas fa-info-circle mr-3' />
                { 'No Customer Orders found based on your filters.' }
              </td>
            </tr>
          )
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <ListPagination
        pagination={ pagination }
        onClickPage={ onPageChange }
      />

      <TableContentWithLoader isLoading={ isLoading } />

      <ListPagination
        pagination={ pagination }
        onClickPage={ onPageChange }
      />
    </>
  )
}


CustomerOrderTable.propTypes    = propTypes
CustomerOrderTable.defaultProps = defaultProps

export default CustomerOrderTable
